/*
  PULLORAX - pre-order + in-stock in one cart: the shopper chooses how it ships
  (owner-approved 10 Oct 2026).

  1. TOGETHER (default): the whole order ships in one parcel once the pre-order
     item is released. One shipping fee. Recorded on the order as the cart
     attribute "Pre-order shipping".
  2. SPLIT: the in-stock items ship now. Shopify charges one shipping fee per
     order, so the pre-order lines are taken OUT of this cart and kept in this
     browser (localStorage); the shopper pays for the in-stock items, and the
     pre-order is offered back afterwards as an order of its own, with its own
     shipping fee. Nothing is charged twice and nothing ships at the store's cost.

  Which lines are pre-orders, the ship-after date and every string come from
  sections/pullorax-po-cart.liquid (per product, from its own release date - no
  date lives in this file). The panel is drawn into the two [data-px-po-slot]
  elements of the cart page (summary + empty cart) and, in the cart drawer, as
  the last child of the scrolling list (#pxDrawerBody) - the drawer rebuilds
  that list on every cart change, so the panel is put back after each rebuild
  and scrolls with the lines instead of squeezing them on a small phone.
*/
(function () {
  'use strict';
  var tag = document.querySelector('script[data-px-po]');
  var drawer = document.getElementById('pxDrawer2'), drawerBody = document.getElementById('pxDrawerBody');
  var pageSlots = Array.prototype.slice.call(document.querySelectorAll('[data-px-po-slot]'));
  if (!tag || (!pageSlots.length && !drawerBody) || !window.fetch) return;

  var root = tag.getAttribute('data-root') || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var STASH = 'px-po-stash', OPENED = 'px-po-opened', ATTR = 'Pre-order shipping';
  // The set-aside lines as "variant:qty,variant:qty". It travels with the order, so the order
  // e-mail can link back to /cart?po_restore=<that value> and put the pre-order in the cart.
  var ATTR_ITEMS = 'Pre-order set aside';
  var V_TOGETHER = 'Ship everything together / הכול במשלוח אחד';
  var V_SPLIT = 'Split: pre-order ordered separately / פיצול: ההזמנה המוקדמת בנפרד';
  var MAX_AGE = 14 * 24 * 60 * 60 * 1000;
  var onCartPage = !!document.querySelector('.px-cart__form, .px-cart__empty');
  var busy = false, queued = false, timer = null;

  function readStash() {
    try {
      var s = JSON.parse(localStorage.getItem(STASH) || 'null');
      if (!s || !Array.isArray(s.items) || !s.items.length) return null;
      if (!s.t || Date.now() - s.t > MAX_AGE) { localStorage.removeItem(STASH); return null; }
      return s;
    } catch (e) { return null; }
  }
  function writeStash(items) {
    try {
      if (items && items.length) localStorage.setItem(STASH, JSON.stringify({ t: Date.now(), items: items }));
      else localStorage.removeItem(STASH);
      return true;
    } catch (e) { return false; }
  }
  function json(r) {
    return r.json().catch(function () { return {}; }).then(function (d) {
      if (!r.ok) { var e = new Error(d.description || d.message || ''); e.shopify = d.description || d.message || ''; throw e; }
      return d;
    });
  }
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(json); }
  function getData() {
    return fetch(root + '?section_id=pullorax-po-cart', { headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('section');
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('[data-px-po-data]');
      return JSON.parse(el.textContent);
    });
  }
  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
  }
  function asList(items) { return (items || []).map(function (s) { return s.id + ':' + s.quantity; }).join(','); }
  function setAttr(cart, value, list) {
    var now = cart.attributes || {};
    if ((now[ATTR] || '') === value && (now[ATTR_ITEMS] || '') === (list || '')) return Promise.resolve();
    var a = {}; a[ATTR] = value; a[ATTR_ITEMS] = list || '';
    return post('cart/update.js', { attributes: a }).catch(function () {});
  }
  // ?po_restore=variant:qty,variant:qty - the link in the order e-mail of a split order.
  function fromLink() {
    var m = /[?&]po_restore=([^&#]*)/.exec(window.location.search);
    if (!m) return Promise.resolve(false);
    var items = [];
    decodeURIComponent(m[1]).split(',').forEach(function (part) {
      var p = /^(\d{6,20}):(\d{1,3})$/.exec(part.trim());
      if (p && items.length < 20) items.push({ id: parseInt(p[1], 10), quantity: Math.max(1, parseInt(p[2], 10)) });
    });
    try {
      var clean = window.location.pathname + window.location.search.replace(/([?&])po_restore=[^&#]*&?/, '$1').replace(/[?&]$/, '') + window.location.hash;
      window.history.replaceState(null, '', clean);
    } catch (e) {}
    if (!items.length) return Promise.resolve(false);
    return post('cart/add.js', { items: items }).then(function () {
      var st = readStash();
      if (st) { var got = {}; items.forEach(function (i) { got[i.id] = 1; }); writeStash(st.items.filter(function (s) { return !got[s.id]; })); }
      return true;
    }, function () { return false; });
  }
  // a pre-order line without its dates line gets it back (see "fix" in the section)
  // A line is tried at most once a minute (sessionStorage), so a refused change can never loop the page.
  var FIXED = 'px-po-fixed';
  function fixLines(data) {
    var seen = {}, now = Date.now();
    try { seen = JSON.parse(sessionStorage.getItem(FIXED) || '{}') || {}; } catch (e) { return Promise.resolve(false); }
    var todo = (data.fix || []).filter(function (f) { return !(seen[f.key] && now - seen[f.key] < 60000); });
    if (!todo.length || !data.fixKey) return Promise.resolve(false);
    var ok = false;
    todo.forEach(function (f) { seen[f.key] = now; });
    try { sessionStorage.setItem(FIXED, JSON.stringify(seen)); } catch (e) { return Promise.resolve(false); }
    return todo.reduce(function (p, f) {
      return p.then(function () {
        var props = {}; props[data.fixKey] = f.v;
        return post('cart/change.js', { id: f.key, quantity: f.q, properties: props }).then(function () { ok = true; }, function () {});
      });
    }, Promise.resolve()).then(function () { return ok; });
  }
  function sized(u, w) {
    u = String(u || ''); if (!u) return u;
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function el(name, cls, text) {
    var n = document.createElement(name);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function itemList(items) {
    var ul = el('ul', 'px-po__items');
    items.forEach(function (it) {
      var li = el('li', 'px-po__item');
      if (it.image) {
        var img = document.createElement('img');
        img.src = sized(it.image, 128); img.alt = ''; img.width = 48; img.height = 48; img.loading = 'lazy'; img.decoding = 'async';
        li.appendChild(img);
      }
      var name = el('span', 'px-po__name', it.title + (it.quantity > 1 ? ' × ' + it.quantity : ''));
      li.appendChild(name);
      ul.appendChild(li);
    });
    return ul;
  }
  function option(on, title, desc, onLabel, action) {
    var n = el(on ? 'div' : 'button', 'px-po__opt' + (on ? ' is-on' : ''));
    if (!on) { n.type = 'button'; n.setAttribute('data-po', action); }
    var mark = el('span', 'px-po__mark'); mark.setAttribute('aria-hidden', 'true'); if (on) mark.textContent = '✓';
    var txt = el('span', 'px-po__txt');
    txt.appendChild(el('strong', null, title));
    if (on) txt.appendChild(el('span', 'px-visually-hidden', ' (' + onLabel + ')'));
    txt.appendChild(el('span', 'px-po__d', desc));
    n.appendChild(mark); n.appendChild(txt);
    return n;
  }

  function panel(state, data, stash, message) {
    var T = data.t, box = el('div', 'px-po');
    box.setAttribute('role', 'group');
    if (state === 'choice') {
      box.setAttribute('aria-label', T.head);
      box.appendChild(el('p', 'px-po__h', T.head));
      box.appendChild(option(true, T.tog, T.togD + (data.ships ? ' ' + data.ships : ''), T.on));
      box.appendChild(option(false, T.spl, T.splD, T.on, 'split'));
    } else if (state === 'aside') {
      box.setAttribute('aria-label', T.set);
      box.appendChild(el('p', 'px-po__h', T.set));
      box.appendChild(itemList(stash.items));
      box.appendChild(el('p', 'px-po__d', T.setD));
      var back = el('button', 'px-po__link', T.back); back.type = 'button'; back.setAttribute('data-po', 'restore');
      box.appendChild(back);
    } else {
      box.setAttribute('aria-label', T.wait);
      box.appendChild(el('p', 'px-po__h', T.wait));
      box.appendChild(itemList(stash.items));
      box.appendChild(el('p', 'px-po__d', T.waitD));
      var add = el('button', 'px-btn px-btn--ink px-btn--block px-po__add', T.add); add.type = 'button'; add.setAttribute('data-po', 'restore');
      var drop = el('button', 'px-po__link', T.drop); drop.type = 'button'; drop.setAttribute('data-po', 'drop');
      box.appendChild(add); box.appendChild(drop);
    }
    if (message) { var m = el('p', 'px-po__err', message); m.setAttribute('role', 'alert'); box.appendChild(m); }
    return box;
  }

  var view = null;
  function draw(state, data, stash, message) {
    if (drawerBody) {
      var old = drawerBody.querySelector('[data-px-po-slot]');
      if (old) old.parentNode.removeChild(old);
      if (state) {
        var mine = el('div'); mine.setAttribute('data-px-po-slot', 'drawer');
        mine.appendChild(panel(state, data, stash, message));
        drawerBody.appendChild(mine);
      }
    }
    pageSlots.forEach(function (slot) {
      slot.textContent = '';
      if (!state) { slot.hidden = true; return; }
      // the empty-cart slot only ever carries the "waiting" panel; the summary slot never does
      var kind = slot.getAttribute('data-px-po-slot');
      if ((kind === 'empty' && state !== 'waiting') || (kind === 'summary' && state === 'waiting')) { slot.hidden = true; return; }
      slot.appendChild(panel(state, data, stash, message));
      slot.hidden = false;
    });
  }

  function refresh(message) {
    if (busy) { queued = true; return; }
    busy = true;
    Promise.all([getCart(), getData()]).then(function (res) {
      var cart = res[0], data = res[1], stash = readStash();
      var isPo = {}; (data.po || []).forEach(function (k) { isPo[k] = 1; });
      var poLines = [], inLines = [];
      (cart.items || []).forEach(function (it) { (isPo[it.key] ? poLines : inLines).push(it); });

      // a pre-order line back in the cart is no longer "set aside"
      if (stash && poLines.length) {
        var inCart = {}; poLines.forEach(function (it) { inCart[it.variant_id] = 1; });
        var left = stash.items.filter(function (s) { return !inCart[s.id]; });
        if (left.length !== stash.items.length) { writeStash(left); stash = readStash(); }
      }

      var state = null;
      if (poLines.length && inLines.length) state = 'choice';
      else if (stash && !poLines.length && inLines.length) state = 'aside';
      else if (stash && !cart.items.length) state = 'waiting';

      view = { cart: cart, data: data, stash: stash, poLines: poLines, state: state };
      draw(state, data, stash, message);

      if (state === 'choice') setAttr(cart, V_TOGETHER, '');
      else if (state === 'aside') setAttr(cart, V_SPLIT, asList(stash.items));
      else if (cart.items.length) setAttr(cart, '', '');

      fixLines(data).then(function (changed) { if (changed) done(); });

      // back from the checkout with the pre-order still waiting: show it once per visit
      if (state === 'waiting' && !onCartPage && drawer && drawer.hasAttribute('hidden')) {
        var seen = false;
        try { seen = !!sessionStorage.getItem(OPENED); sessionStorage.setItem(OPENED, '1'); } catch (e) { seen = true; }
        var opener = document.querySelector('[data-px-cart-open]');
        if (!seen && opener) opener.click();
      }
    }).catch(function () {
      /* no data, no panel: the cart keeps working exactly as before */
    }).then(function () {
      busy = false;
      if (queued) { queued = false; refresh(); }
    });
  }

  function done() {
    if (onCartPage) { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent('px:cart:refresh'));
    refresh();
  }
  function lock(on) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-px-po-slot] button'), function (b) { b.disabled = on; });
  }

  function split() {
    if (!view || !view.poLines.length) return;
    var keep = (view.stash ? view.stash.items : []).slice();
    var updates = {};
    view.poLines.forEach(function (it) {
      updates[it.key] = 0;
      keep.push({ id: it.variant_id, quantity: it.quantity, properties: it.properties || {}, title: it.product_title, image: it.image || '' });
    });
    // without storage the pre-order could not be offered back - leave the cart as it is
    if (!writeStash(keep)) { draw(view.state, view.data, view.stash, view.data.t.err); return; }
    var a = {}; a[ATTR] = V_SPLIT; a[ATTR_ITEMS] = asList(keep);
    lock(true);
    post('cart/update.js', { updates: updates, attributes: a }).then(done, function (e) {
      writeStash(view.stash ? view.stash.items : []);
      draw(view.state, view.data, view.stash, (e && e.shopify) || view.data.t.err);
    });
  }
  function restore() {
    if (!view || !view.stash) return;
    var items = view.stash.items.map(function (s) {
      var line = { id: s.id, quantity: s.quantity };
      if (s.properties && Object.keys(s.properties).length) line.properties = s.properties;
      return line;
    });
    lock(true);
    post('cart/add.js', { items: items }).then(function () {
      writeStash([]);
      done();
    }, function (e) {
      draw(view.state, view.data, view.stash, (e && e.shopify) || view.data.t.err);
    });
  }
  function drop() { writeStash([]); refresh(); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-po]');
    if (!b || b.disabled) return;
    var slot = b.closest('[data-px-po-slot]'); if (!slot) return;
    e.preventDefault();
    var act = b.getAttribute('data-po');
    if (act === 'split') split(); else if (act === 'restore') restore(); else if (act === 'drop') drop();
  });

  // the drawer re-renders its list on every cart change - follow it
  if (drawerBody && window.MutationObserver) {
    new MutationObserver(function (records) {
      // our own panel going in or out is not a cart change
      var foreign = records.some(function (r) {
        return Array.prototype.concat.call(Array.prototype.slice.call(r.addedNodes), Array.prototype.slice.call(r.removedNodes)).some(function (n) {
          return !(n.nodeType === 1 && n.hasAttribute('data-px-po-slot'));
        });
      });
      if (!foreign) return;
      clearTimeout(timer);
      timer = setTimeout(function () { refresh(); }, 120);
    }).observe(drawerBody, { childList: true });
  }
  fromLink().then(function (added) {
    if (added && onCartPage) { window.location.reload(); return; }
    if (added) document.dispatchEvent(new CustomEvent('px:cart:refresh'));
    refresh();
  });
})();
